import { ChevronRight } from 'assets/icons';
import Badge from 'components/badge/badge';
import { useEffect, useRef } from 'react';

/** The steps of a slide-over wizard, on a single scrollable line that follows
 *  the step in progress. */
const TemplateStepBadges = ({ steps, currentKey, onSelect }) => {
  const listRef = useRef(null);
  const currentRef = useRef(null);

  useEffect(() => {
    const list = listRef.current;
    const current = currentRef.current;
    if (!list || !current) return;
    // Scrolling the list itself, rather than scrollIntoView, which would also
    // move the panel the list sits in.
    list.scrollTo({
      left: Math.max(
        0,
        current.offsetLeft - (list.clientWidth - current.clientWidth) / 2
      ),
      behavior: 'smooth',
    });
  }, [currentKey]);

  return (
    <div
      ref={listRef}
      className="relative flex items-center gap-2 overflow-x-auto no-scrollbar"
    >
      {steps.map((step, index) => (
        <div
          key={step.key}
          ref={currentKey === step.key ? currentRef : null}
          className="flex items-center gap-2 shrink-0"
        >
          <Badge
            type={currentKey === step.key ? 'WARNING' : 'SECONDARY'}
            size="LG"
            onClick={() => onSelect(step.key)}
          >
            {step.label}
          </Badge>
          {index < steps.length - 1 && <ChevronRight wh={16} color="#374151" />}
        </div>
      ))}
    </div>
  );
};

export default TemplateStepBadges;
